<template>
  <header>
    <div class="firstLine">
      <a @click="$root.track($root.events.NAVIGATION, { name: 'phone' })" href="tel:72 11 60 00">
        <PhoneIcon />
        72 11 60 00
      </a>
      <a @click="$root.track($root.events.NAVIGATION, { name: 'email' })" href="mailto:info@starmark.dk">info@starmark.dk</a>
      <div class="sessionMenu" v-click-outside="clickedOutside">
        <button ref="profileBtn" @click="hide = !hide" class="myProfileBtn"><img src="@/resources/profile.png" alt="" /> Min Profil</button>
        <Transition>
          <nav v-if="!hide">
            <ul>
              <li v-if="!$root.user"><button id="header_login-btn" aria-label="login button" @click="$root.login">Log ind</button></li>
              <li @click="$root.track($root.events.NAVIGATION, { name: 'saved_searches' })">
                <router-link to="/min/mine-soegninger" aria-label="saved searches link" data-test-id="header_my_saved_searches"> Gemte søgninger </router-link>
              </li>
              <li @click="$root.track($root.events.NAVIGATION, { name: 'favorites' })">
                <router-link to="/min/favoritter" aria-label="favorites link" data-test-id="header_my_favorites"> Favoritter </router-link>
              </li>
              <li @click="$root.track($root.events.NAVIGATION, { name: 'tradeins' })" v-if="$root.user">
                <router-link to="/min/byttebil" aria-label="my tradeins link" data-test-id="header_my_tradeins"> Byttebil </router-link>
              </li>
              <li @click="$root.track($root.events.NAVIGATION, { name: 'orders' })" v-if="$root.user">
                <router-link to="/min/ordrer" aria-label="my orders link" data-test-id="header_my_orders"> Ordrer </router-link>
              </li>
              <li @click="$root.track($root.events.NAVIGATION, { name: 'my_account' })" v-if="$root.user">
                <router-link to="/min/konto" aria-label="my account link" data-test-id="header_my_account">Konto indstillinger</router-link>
              </li>
              <li @click="$root.track($root.events.NAVIGATION, { name: 'logout' })" v-if="$root.user"><button id="header_logout_btn" aria-label="logout button" @click="logout">Log ud</button></li>
            </ul>
          </nav>
        </Transition>
      </div>
    </div>
    <div class="secondLine">
      <a @click="$root.track($root.events.NAVIGATION, { name: 'Home' })" href="/">
        <svg aria-label="Starmark" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144 25">
          <path
            fill="#fff"
            d="M.237 17.18h.71c.593 4.266 2.37 6.398 5.214 6.398 2.37 0 4.028-1.895 4.028-4.62 0-1.422-.474-2.607-1.303-3.318-.592-.593-.83-.711-2.843-1.896-3.318-2.014-3.91-2.607-4.621-3.554-.593-1.067-.83-2.252-.83-3.555 0-3.673 2.251-6.28 5.569-6.28 1.659 0 2.725.474 3.91 1.896L10.9.237h.473v6.517h-.592C10.07 3.199 8.649 1.54 6.398 1.54c-2.133 0-3.673 1.896-3.673 4.266 0 1.896.71 2.725 3.199 4.265l1.303.83c1.896 1.184 2.607 1.54 3.318 2.25 1.185 1.067 1.777 2.726 1.777 4.622 0 4.028-2.37 6.753-5.924 6.753-1.777 0-3.2-.592-4.62-2.014l-.949 2.37H.237V17.18zM22.512 1.777V21.21c0 1.895.237 2.132 2.37 2.37v.829c-1.778-.237-2.489-.237-3.673-.237-1.185 0-1.896.118-3.673.237v-.83h.355c1.777-.237 2.133-.474 2.133-2.37V1.779h-1.54c-2.133 0-2.844.829-3.674 4.265h-.71l.829-5.45h12.915l.83 5.45h-.712c-.83-3.555-1.422-4.266-3.436-4.266h-2.014zM35.782 5.569l2.843 10.9h-6.16l3.317-10.9zm4.147 15.758l.118.592c0 .237.119.474.119.474 0 .711-.474.948-1.896 1.185v.83c1.659-.237 2.251-.237 3.554-.237 1.304 0 1.896.118 3.555.237v-.83c-1.896-.118-2.251-.474-2.725-2.133L36.493 0l-6.754 21.09c-.592 2.014-.948 2.37-2.844 2.488v.83c1.304-.119 1.896-.119 2.844-.119s1.422 0 2.844.119v-.83c-1.54-.118-1.896-.355-1.896-1.185 0-.355.118-.829.355-1.658l.948-3.318h6.872l1.067 3.91zM51.303 1.777h2.607c2.725 0 4.147 1.777 4.147 4.977 0 3.436-1.54 5.213-4.266 5.213h-2.488V1.777zm1.067 11.375c1.895 0 2.606.592 3.317 2.843l2.251 6.398c.356.948.474 1.304.83 2.133.948-.119 1.303-.119 1.895-.119.593 0 .948 0 1.896.119v-.83c-1.422-.118-1.777-.355-2.37-2.014l-2.014-5.568c-.71-1.896-1.303-2.607-2.488-3.08 1.185-.238 1.54-.356 2.251-.83 1.54-.948 2.488-2.962 2.488-5.095 0-2.014-.829-4.028-2.25-5.095-1.067-.83-2.252-1.185-4.03-1.185h-7.819v.83c2.133.118 2.37.474 2.37 2.37v17.298c0 1.777-.356 2.133-2.133 2.37h-.355v.829c1.895-.237 2.606-.237 3.672-.237 1.185 0 1.896.118 3.673.237v-.83H53.2c-1.777-.118-2.133-.473-2.133-2.369V13.27h1.304v-.118zM68.246 2.844l-.592 18.364v.356c0 1.54.355 1.896 2.488 2.014v.83c-1.54-.119-2.133-.119-2.962-.119-.83 0-1.422 0-2.962.118v-.829c2.014-.118 2.37-.474 2.37-2.37l.592-17.417v-.237c0-1.658-.474-2.014-2.488-2.132v-.83c1.184.119 1.54.119 2.37.119 1.066 0 1.658 0 2.843-.237l5.45 17.89L80.924.475c1.303.118 1.896.237 2.843.237.711 0 1.185 0 2.37-.119v.83c-2.014.118-2.488.474-2.488 2.132v.237l.474 17.418c0 1.895.237 2.25 2.37 2.37v.828c-1.896-.236-2.607-.236-3.673-.236-1.067 0-1.778.118-3.673.236v-.829c2.014-.118 2.488-.474 2.488-2.251v-.119l-.356-18.364-4.857 15.758-.356 1.185-.474 1.303-.355 1.422-.356 1.185h-.474l-.355-1.185-.474-1.422-.118-1.303-.356-1.185-4.858-15.758zM96.445 5.569l2.844 10.9h-6.161l3.317-10.9zm4.147 15.758l.119.592c0 .237.118.474.118.474 0 .711-.474.948-1.895 1.185v.83c1.658-.237 2.251-.237 3.554-.237s1.896.118 3.555.237v-.83c-1.896-.118-2.252-.474-2.725-2.133L97.275 0 90.52 21.09c-.592 2.014-.948 2.37-2.843 2.488v.83c1.303-.119 1.895-.119 2.843-.119s1.422 0 2.844.119v-.83c-1.54-.118-1.896-.355-1.896-1.185 0-.355.119-.829.356-1.658l.947-3.318h6.754l1.066 3.91zM112.204 1.777h2.606c2.725 0 4.147 1.659 4.147 4.977 0 3.436-1.54 5.213-4.265 5.213h-2.488V1.777zm1.066 11.375c1.896 0 2.607.592 3.318 2.843l2.251 6.398c.355.948.474 1.304.829 2.133.948-.119 1.303-.119 1.896-.119.592 0 .948 0 1.896.119v-.83c-1.422-.118-1.778-.355-2.37-2.014l-2.014-5.568c-.711-1.896-1.304-2.607-2.488-3.08 1.184-.238 1.54-.356 2.251-.83 1.54-.948 2.488-2.962 2.488-5.095 0-2.014-.829-4.028-2.251-5.095-1.067-.83-2.251-1.185-4.029-1.185h-7.82v.83c2.133.118 2.37.474 2.37 2.37v17.298c0 1.777-.355 2.133-2.133 2.37h-.355v.829c1.896-.237 2.607-.237 3.673-.237 1.185 0 1.896.118 3.673.237v-.83h-.356c-1.777-.118-2.132-.473-2.132-2.369V13.27h1.303v-.118zM130.569 11.967l6.635-8.886c.237-.356.474-.593.474-.83 0-.592-.237-.71-1.777-.83V.594c1.421.118 1.895.118 2.962.118 1.066 0 1.54 0 2.962-.118v.829c-1.778.118-2.488.474-3.555 1.896l-5.095 6.753 6.635 11.256c.948 1.659 1.659 2.133 3.318 2.251v.83c-1.777-.237-2.488-.237-3.791-.237-1.304 0-2.015.118-3.91.237v-.83c1.658-.118 2.014-.355 2.014-.948 0-.236-.119-.473-.237-.71l-.237-.474-5.332-9.48-1.185 1.541v7.702c0 1.895.237 2.132 2.37 2.37v.829c-1.659-.237-2.251-.237-3.436-.237s-1.896.118-3.673.237v-.83c2.133-.237 2.37-.474 2.37-2.37V3.793c0-1.896-.356-2.133-2.37-2.37v-.83c1.896.237 2.607.237 3.673.237 1.185 0 1.896-.118 3.554-.236v.829c-2.132.118-2.488.474-2.488 2.37v8.175h.119z"
          />
          <defs>
            <path fill="#fff" d="M0 0h143.483v25H0z" />
          </defs>
        </svg>
      </a>
      <NavBar @login="$root.login" :class="{ hideNavbar: hideNavbar }" />
      <button @click="hideNavbar = !hideNavbar" class="mobileMenuButton">
        <svg class="block fill-current" aria-hidden="true" width="28" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0" width="28" height="3" fill="#fff" />
          <rect y="10" width="28" height="3" fill="#fff" />
          <rect y="20" width="28" height="3" fill="#fff" />
        </svg>
        <span>Menu</span>
      </button>
    </div>
  </header>
</template>

<script>
import NavBar from './Navbar.vue'
import PhoneIcon from '../../resources/icons/phone_icon.svg'
import { ROUTES } from '../../router'

export default {
  name: 'HeaderComponet',
  components: { NavBar, PhoneIcon },
  data() {
    return {
      hideNavbar: true,
      hide: true
    }
  },
  computed: {
    routes() {
      return ROUTES
    }
  },
  methods: {
    logout() {
      window.seezSdk.showLogout()
    },
    clickedOutside() {
      this.hide = true
    }
  }
}
</script>

<style lang="scss">
.hideNavbar {
  display: none;

  @media screen and (min-width: 768px) {
    display: block;
  }
}

header {
  inset: 0 0 auto 0;
  z-index: 3;
  position: fixed;
  display: grid;
  justify-items: stretch;
  padding: 0;
  background-color: black;

  @media print {
    display: none;
  }

  @media screen and (min-width: 768px) {
    position: static;
  }

  > .firstLine {
    background-color: rgba(51, 51, 51, 1);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 1rem;
    height: 28px;
    font-size: 14px;
    padding: 0 1rem;

    > a {
      text-decoration: none;
      color: #a7a7a7;
      display: flex;
      align-items: center;

      svg {
        padding-inline-end: 0.5rem;
      }
    }

    > .sessionMenu {
      display: none;
    }

    @media screen and (min-width: 768px) {
      gap: 2.1rem;
      padding: 0 calc(50vw - 49rem);

      > .sessionMenu {
        display: block;
        position: relative;

        > .myProfileBtn {
          background-color: #5bc2f4;
          font-size: 14px;
          text-transform: uppercase;
          text-decoration: none;
          white-space: nowrap;
          transition: background-color 0.2s;
          font-family: var(--font-family);
          font-weight: 400;
          color: white;
          border: none;
          cursor: pointer;

          @media screen and (min-width: 768px) {
            display: block;
            padding: 2px 10px 0 7px;
            line-height: 26px;
          }

          &:hover {
            opacity: 0.9;
          }

          > img {
            margin: 0 0.2rem;
            transform: translateY(0.01rem);
          }
        }

        > nav {
          color: white;
          background-color: black;
          position: absolute;
          top: 1.9rem;
          border-radius: 12px;
          z-index: 2;
          right: 0;
          border: 1px solid #333;
          max-height: 14rem;
          overflow: hidden;

          > ul {
            > li {
              margin: 1rem;
              white-space: nowrap;
            }
            > li > a {
              text-decoration: none;
            }

            > li,
            button {
              font-family: 'Corporate S';
              font-weight: 400;
              text-transform: uppercase;
              font-size: 0.7777rem;
              cursor: pointer;
              &:hover {
                opacity: 0.8;
              }

              > button {
                color: white;
                padding: 0;
                width: 100%;
                text-align: start;
                background-color: transparent;
              }
            }
          }
        }
      }
    }
  }

  > .secondLine {
    width: calc(100% - 2rem);
    max-width: 98rem;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 58px;

    @media screen and (min-width: 768px) {
      height: 92px;
    }

    > a > svg {
      width: clamp(110px, 20vw, 240px);
      @media screen and (min-width: 768px) {
        width: clamp(160px, 20vw, 240px);
      }
    }

    > .mobileMenuButton {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: transparent;
      border: none;
      color: white;
      text-transform: uppercase;
      margin-top: 0.2rem;
      cursor: pointer;

      @media screen and (min-width: 768px) {
        display: none;
      }

      > span {
        padding: 0.2rem 0;
        font-size: 10px;
      }
    }
  }
}

.v-enter-active,
.v-leave-active {
  transition: max-height 0.25s ease-in-out;
}

.v-enter-from,
.v-leave-to {
  max-height: 0 !important;
}
</style>
